<template>
    <div class="skeleton-master-detail-layout">
        <!-- 왼쪽: 마스터 패널 스켈레톤 -->
        <div class="skeleton-master-panel">
            <div class="skeleton-master-header">
                <div class="skeleton-master-header-left">
                    <div class="skeleton-box" style="width: 80px; height: 14px;"></div>
                    <div class="skeleton-box" style="width: 40px; height: 12px;"></div>
                </div>
                <div class="skeleton-circle" style="width: 28px; height: 28px;"></div>
            </div>
            <div class="skeleton-master-list">
                <div v-for="i in 5" :key="i" class="skeleton-master-item">
                    <div class="skeleton-master-item-main">
                        <div class="skeleton-master-item-header">
                            <div class="skeleton-master-item-header-left">
                                <div class="skeleton-box" style="width: 70%; height: 13px;"></div>
                            </div>
                            <div class="skeleton-circle" style="width: 16px; height: 16px;"></div>
                        </div>
                        <div class="skeleton-master-item-info">
                            <div class="skeleton-info-row">
                                <div class="skeleton-box" style="width: 32px; height: 11px;"></div>
                                <div class="skeleton-box" style="width: 60%; height: 11px;"></div>
                            </div>
                            <div class="skeleton-info-row">
                                <div class="skeleton-box" style="width: 32px; height: 11px;"></div>
                                <div class="skeleton-box" style="width: 50%; height: 11px;"></div>
                            </div>
                        </div>
                        <div class="skeleton-master-item-meta">
                            <div class="skeleton-box" style="width: 80%; height: 11px; margin-bottom: 2px;"></div>
                            <div class="skeleton-box" style="width: 60%; height: 11px;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 오른쪽: 디테일 패널 스켈레톤 -->
        <div class="skeleton-detail-panel">
            <div class="skeleton-detail-header">
                <div class="skeleton-detail-header-main">
                    <div class="skeleton-detail-title-row">
                        <div class="skeleton-box" style="width: 150px; height: 18px; margin-bottom: 6px;"></div>
                        <div class="skeleton-detail-header-meta">
                            <div class="skeleton-box" style="width: 100px; height: 11px;"></div>
                            <div class="skeleton-box" style="width: 80px; height: 11px;"></div>
                        </div>
                    </div>
                    <div class="skeleton-detail-header-info">
                        <div class="skeleton-info-item">
                            <div class="skeleton-box" style="width: 50px; height: 10px; margin-bottom: 2px;"></div>
                            <div class="skeleton-box" style="width: 80px; height: 12px;"></div>
                        </div>
                        <div class="skeleton-info-item">
                            <div class="skeleton-box" style="width: 50px; height: 10px; margin-bottom: 2px;"></div>
                            <div class="skeleton-box" style="width: 100px; height: 12px;"></div>
                        </div>
                        <div class="skeleton-info-item">
                            <div class="skeleton-box" style="width: 50px; height: 10px; margin-bottom: 2px;"></div>
                            <div class="skeleton-box" style="width: 120px; height: 12px;"></div>
                        </div>
                        <div class="skeleton-info-item">
                            <div class="skeleton-box" style="width: 30px; height: 10px; margin-bottom: 2px;"></div>
                            <div class="skeleton-box" style="width: 150px; height: 12px;"></div>
                        </div>
                        <div class="skeleton-info-item">
                            <div class="skeleton-box" style="width: 80px; height: 10px; margin-bottom: 2px;"></div>
                            <div class="skeleton-box" style="width: 60px; height: 12px;"></div>
                        </div>
                    </div>
                </div>
                <div class="skeleton-detail-header-actions">
                    <div class="skeleton-box" style="width: 80px; height: 28px; border-radius: 20px;"></div>
                    <div class="skeleton-circle" style="width: 28px; height: 28px;"></div>
                    <div class="skeleton-circle" style="width: 28px; height: 28px;"></div>
                    <div class="skeleton-circle" style="width: 28px; height: 28px;"></div>
                </div>
            </div>

            <div class="skeleton-detail-body">
                <!-- 탭 헤더 -->
                <div class="skeleton-tabs">
                    <div class="skeleton-tab-item">
                        <div class="skeleton-box" style="width: 60px; height: 14px;"></div>
                        <div class="skeleton-box" style="width: 20px; height: 20px; border-radius: 10px;"></div>
                    </div>
                    <div class="skeleton-tab-item">
                        <div class="skeleton-box" style="width: 60px; height: 14px;"></div>
                        <div class="skeleton-box" style="width: 20px; height: 20px; border-radius: 10px;"></div>
                    </div>
                </div>

                <!-- 테이블 스켈레톤 -->
                <div class="skeleton-board-panel">
                    <div class="skeleton-board-header-compact">
                        <div class="skeleton-box" style="width: 50px; height: 28px;"></div>
                    </div>
                    <div class="skeleton-table-wrapper">
                        <div class="skeleton-table">
                            <div class="skeleton-table-header">
                                <div class="skeleton-box" style="width: 80px; height: 11px;"></div>
                                <div class="skeleton-box" style="width: 60px; height: 11px;"></div>
                                <div class="skeleton-box" style="width: 50px; height: 11px;"></div>
                                <div class="skeleton-box" style="width: 60px; height: 11px;"></div>
                                <div class="skeleton-box" style="width: 50px; height: 11px;"></div>
                                <div class="skeleton-box" style="width: 80px; height: 11px;"></div>
                            </div>
                            <div v-for="i in 3" :key="i" class="skeleton-table-row">
                                <div class="skeleton-box" style="width: 100px; height: 13px;"></div>
                                <div class="skeleton-box" style="width: 70px; height: 13px;"></div>
                                <div class="skeleton-box" style="width: 50px; height: 13px;"></div>
                                <div class="skeleton-box" style="width: 60px; height: 13px;"></div>
                                <div class="skeleton-box" style="width: 50px; height: 20px; border-radius: 12px;"></div>
                                <div class="skeleton-box" style="width: 100px; height: 24px;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BoundaryTableSkeleton'
};
</script>

<style scoped>
/* 마스터-디테일 레이아웃 스켈레톤 */
.skeleton-master-detail-layout {
    display: flex;
    height: 100%;
    min-height: 600px;
    gap: 0;
    background: #ffffff;
    border-radius: 10px;
    overflow: hidden;
}

/* 마스터 패널 스켈레톤 */
.skeleton-master-panel {
    width: 320px;
    min-width: 280px;
    background: #f8fafc;
    border-right: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.skeleton-master-header {
    padding: 14px 16px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.skeleton-master-header-left {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
}

.skeleton-master-list {
    flex: 1;
    overflow-y: auto;
    padding: 8px;
}

.skeleton-master-item {
    padding: 12px 14px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
}

.skeleton-master-item-main {
    flex: 1;
    min-width: 0;
}

.skeleton-master-item-meta {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

/* 디테일 패널 스켈레톤 */
.skeleton-detail-panel {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    overflow: hidden;
}

.skeleton-detail-header {
    padding: 16px 20px;
    background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
}

.skeleton-detail-header-main {
    flex: 1;
    min-width: 0;
}

.skeleton-detail-header-meta {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-top: 8px;
}

.skeleton-detail-header-actions {
    display: flex;
    gap: 6px;
    align-items: center;
    flex-shrink: 0;
}

.skeleton-detail-body {
    flex: 1;
    padding: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}

.skeleton-detail-title-row {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 8px;
}

.skeleton-detail-header-info {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 8px 12px;
}

.skeleton-info-item {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 6px 0;
}

/* 탭 스켈레톤 */
.skeleton-tabs {
    display: flex;
    gap: 8px;
    padding: 10px;
    background: #fafbfc;
    border-bottom: 1px solid #e2e8f0;
}

.skeleton-tab-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
}

/* 테이블 스켈레톤 */
.skeleton-board-panel {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    min-height: 0;
    flex: 1;
}

.skeleton-board-header-compact {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 10px;
    background: #fafbfc;
}

.skeleton-table-wrapper {
    flex: 1;
    overflow: auto;
    padding: 0;
}

.skeleton-table {
    width: 100%;
    background: #ffffff;
}

.skeleton-table-header {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 120px;
    gap: 12px;
    padding: 10px;
    background: #fafbfc;
    border-bottom: 1px solid #e2e8f0;
}

.skeleton-table-row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 120px;
    gap: 12px;
    padding: 12px;
    border-bottom: 1px solid #f1f5f9;
}

.skeleton-master-item-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 8px;
}

.skeleton-master-item-header-left {
    flex: 1;
}

.skeleton-master-item-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 8px;
    padding: 8px 0;
    border-top: 1px solid #f1f5f9;
    border-bottom: 1px solid #f1f5f9;
}

.skeleton-info-row {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 11px;
}

/* 스켈레톤 박스 (shimmer 효과) */
.skeleton-box {
    background: linear-gradient(
        90deg,
        #e2e8f0 0%,
        #f1f5f9 50%,
        #e2e8f0 100%
    );
    background-size: 200% 100%;
    border-radius: 4px;
    animation: shimmer 1.5s infinite;
}

/* 스켈레톤 원형 (버튼용) */
.skeleton-circle {
    background: linear-gradient(
        90deg,
        #e2e8f0 0%,
        #f1f5f9 50%,
        #e2e8f0 100%
    );
    background-size: 200% 100%;
    border-radius: 50%;
    animation: shimmer 1.5s infinite;
}

/* Shimmer 애니메이션 */
@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }
    100% {
        background-position: 200% 0;
    }
}

/* 반응형 */
@media (max-width: 1024px) {
    .skeleton-master-detail-layout {
        flex-direction: column;
    }
    
    .skeleton-master-panel {
        width: 100%;
        min-width: 0;
        max-height: 300px;
        border-right: none;
        border-bottom: 1px solid #e2e8f0;
    }
    
    .skeleton-detail-panel {
        flex: 1;
        min-height: 400px;
    }
}
</style>

